document.addEventListener('DOMContentLoaded', function () {
    window.hey = function (event) {
        let metricSystem = '';
        if (event.value === 'inch') {
            metricSystem = 'inch';
        } else {
            metricSystem = 'cm';
        }

        document.querySelectorAll('.size-table').forEach(function (item) {
            item.dataset.system = metricSystem;
        })
    }

    if (document.querySelector('.product-media-modal__content')){
        document.querySelector('.product-media-modal__toggle.modal-close-button').addEventListener('click', function (){
            document.querySelector('.js-image-zoom.active').classList.remove('active');
        });

        document.querySelectorAll('.product-media-modal__item').forEach(function (item){
            item.addEventListener('click', function (){
                document.querySelector('.product-media-modal__toggle.modal-close-button').dispatchEvent(new Event('click'));
                // document.querySelector('.product-media-modal__toggle.modal-close-button').click();
            })
        })
    }
})
